module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-600.f50b4ae7.svg";